import axios from 'axios';
import jwtDefaultConfig from './jwtDefaultConfig';

const jwtConfig = { ...jwtDefaultConfig };

const JwtService = () => {

  function removeUserFromStorage() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('client');
    localStorage.removeItem('uid');
    localStorage.removeItem('userData');
    location.reload();
  }

  function getToken(jwtConfig) {
    return localStorage.getItem(jwtConfig.storageTokenKeyName) || null;
  }

  function getClient(jwtConfig) {
    return localStorage.getItem(jwtConfig.storageClientKeyName) || null;
  }

  function getUid(jwtConfig) {
    return localStorage.getItem(jwtConfig.storageUidName) || null;
  }

  function login(...args) {
    return axios.post(jwtConfig.loginEndpoint, ...args);
  }

  return { login, jwtConfig, getToken, getClient, getUid, removeUserFromStorage };
};

export default JwtService;

const { getToken, getClient, getUid, removeUserFromStorage } = JwtService();

// Interceptor de requisição
axios.interceptors.request.use(
  (config) => {
    const accessToken = getToken(jwtConfig);
    const client = getClient(jwtConfig);
    const uid = getUid(jwtConfig);

    // Adicionar os headers somente se os valores existirem
    if (accessToken) {
      config.headers['access-token'] = accessToken;
    }
    if (client) {
      config.headers['client'] = client;
    }
    if (uid) {
      config.headers['uid'] = uid;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    const headerToken = response.headers?.['access-token'] || null; // Pega o token do header da resposta
    const configHeaderToken = response?.config?.headers['access-token'] || null; // Pega o token usado na requisição

    if(!headerToken) {
      localStorage.setItem(
        jwtConfig.storageTokenKeyName,
        configHeaderToken 
      );
    } else {
      localStorage.setItem(
        jwtConfig.storageTokenKeyName,
        headerToken 
      );
    }

    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      removeUserFromStorage(); 
    }

    return Promise.reject(error); 
  }
);
